import { Heading, Para, Stack } from '@drycut/ui-components';

import { CleanHairInfoButton } from './CleanHairInfoButton';

type Props = {
  manual: boolean;
};

export function CheckoutIntroText({ manual }: Props): React.ReactElement {
  if (!manual) {
    return (
      <Para className="max-w-prose text-center mx-auto" pretty>
        Hoi! Hier kannst Du Dich für Deinen Cut anmelden. Bitte denk daran, dass das Resultat dann
        am Besten wird, wenn Du mit sauberen Haaren zum Termin kommst. Wir freuen uns auf Dich!
      </Para>
    );
  }

  return (
    <Stack className="text-center max-w-prose items-center mx-auto">
      <Heading variant="h2" className="text-primary-600 text-2xl font-aribau font-semibold">
        Melde Dich für den nächsten freien Termin an!
      </Heading>

      <Stack direction="row" className="mt-4">
        <Para size="sm">Bitte beachte unsere Clean Hair Policy</Para>
        <CleanHairInfoButton />
      </Stack>

      <Para size="sm">Sei gerne 5 Min. vor Deinem Termin im Salon</Para>
    </Stack>
  );
}
